import {ICurrentInfo, IExtFields} from './../../@types/global.d'
import {Module, VuexModule, getModule, MutationAction, Mutation} from 'vuex-module-decorators'
import store from '@/store'
// import { Message } from 'element-ui'
import {getCountryList} from '@/api/common'
import {ICountryData} from '@/@types/global'

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'Common'
})
export default class Common extends VuexModule {
  countryList: ICountryData[] = []

  @MutationAction
  async initCountryList() {
    try {
      const res: any = await getCountryList()
      const countryList = res.list
      return {countryList}
    } catch (err: any) {
      // Message.error(err.message)
      console.log(err)
    }
  }

  menuId = ''

  @Mutation
  SET_MENU_ID(id: string) {
    this.menuId = id
  }

  subMenuId = 0

  @Mutation
  SET_SUBMENU_ID(id: number) {
    this.subMenuId = id
  }

  selectedSubItem = {}

  @Mutation
  SET_SELECTED_SUB_ITEM(item: any) {
    this.selectedSubItem = item
  }


  // 一个状态，用于判断是否需要更新列表数据
  isNeedInitData = false

  @Mutation
  HANDLE_INIT_STORE_DATA(isNeedInitData: boolean) {
    this.isNeedInitData = isNeedInitData
  }

  // 一个状态，用于判断是否要显示右侧的导航列表
  isHideRightBar = true

  @Mutation
  Handle_SHOW_RIGHT_BAR(bool: boolean) {
    this.isHideRightBar = bool
  }

  // 一个状态，用于触发菜单初始化
  isNeedInitMenu = false

  @Mutation
  HANDLE_INIT_MENU(bool: boolean) {
    this.isNeedInitMenu = bool
  }

  // 全局接口请求loading状态
  globalLoading: any[] = []

  @Mutation
  SHOW_LOADING(bool: boolean) {
    if (bool) {
      this.globalLoading.push(1)
    } else {
      this.globalLoading.pop()
    }
  }

  currentSubMenuID: Number = 0
  currentCountrys: any[] = []
  currentExtField?: IExtFields = {}
  currentInfo: ICurrentInfo = {
    name: '',
    Remarks: '',
    Price: '',
    MaxQuantity: 0,
    MinQuantity: 0,
    AddModel:''
  }

  @Mutation
  INIT_EXT_FIELDS(extItem: any) {
    this.currentInfo.name = extItem.name
    this.currentInfo.Remarks = extItem.Remarks
    this.currentInfo.Price = extItem.Price
    this.currentInfo.MinQuantity = extItem.MinQuantity
    this.currentInfo.MaxQuantity = extItem.MaxQuantity
    this.currentSubMenuID = extItem.ID
    this.currentInfo.AddModel = extItem.AddModel
    console.log(extItem)
    if (extItem.ExtFields) {
      this.currentExtField = extItem.ExtFields
    } else {
      this.currentExtField = undefined
    }
    if (extItem.Countrys) {
      this.currentCountrys = extItem.Countrys
    } else {
      this.currentCountrys = []
    }

  }
}

export const CommonModule = getModule(Common)
